module.exports = __webpack_public_path__ + "img/stackslash-process-6-mobile.76837212.jpg";